<template>
	<ChartAxisConfig v-if="leftAxisSync" v-model="leftAxisSync" :name="$t('dashboard.leftAxis')" />
	<ChartAxisConfig
		v-if="bottomAxisSync"
		v-model="bottomAxisSync"
		:name="$t('dashboard.bottomAxis')"
	/>
	<WaveformAxisConfig v-model="waveformSeries" :name="$t('dashboard.waveform.series')" />
</template>

<script lang="ts">
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { defineComponent, PropType } from "vue";
import ChartAxisConfig from "../../config/ChartAxisConfig.vue";
import { defaultEventWaveformOptions, EventWaveformOptions } from "./event-waveform-options";
import WaveformAxisConfig from "./WaveformAxisConfig.vue";

export default defineComponent({
	components: { ChartAxisConfig, WaveformAxisConfig },
	name: "EventWaveformPluginConfig",
	props: {
		modelValue: {
			type: Object as PropType<EventWaveformOptions>,
			default: () => defaultEventWaveformOptions,
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const axesSync = useRefObjectSync(valueModel, "axes");
		const leftAxisSync = useRefObjectSync(axesSync, "left");
		const bottomAxisSync = useRefObjectSync(axesSync, "bottom");
		const waveformSeries = useRefObjectSync(valueModel, "waveformSeries");

		return { leftAxisSync, bottomAxisSync, waveformSeries };
	},
});
</script>
